module.exports = __webpack_public_path__ + "media/images/flags/32/Wallis-And-Futuna-d05468574f79d013541f0153e8744be0.png";